import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import common from '../../styles/common.js';
import '../common/swd-hero.js';
import { generate } from '../../router.js';
import { Routes } from '../../routes.js';
import '../common/facebook-bar.js'

@customElement('home-view')
class HomeView extends LitElement {
  static styles = [
    common,
    css`
      :host {
        display: flex;
        flex-direction: column;
      }
      
      .boxes {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 16px;
        margin-bottom: 60px;
      }
      
      .box {
        flex: 1 1 48%;
        width: 50%;
        min-width: 200px;
        height: 180px;
        background: var(--blue);
        border-radius: 5px;
        text-decoration: none;
        text-align: center;
        vertical-align: middle;
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: #FFF !important;
      }
      
      .box:hover {
        background: var(--bs-primary);
      }
      
      .help {
        margin-bottom: 40px;
      }

      @media (max-width: 767px) {
        .box {
          height: 120px;
        }
      }
    `
  ];

  render() {
    return html`
      <swd-hero
        tall
        srcset="public/assets/images/hero.png 1600w"
        sizes="1600w"
        src="public/assets/images/hero.png"
      >
        <h1>
          PowerBax Standby Power Systems
        </h1>
        <p>
          Providing emergency power and peace of mind for your home.
        </p>
      </swd-hero>
      <main>
        <div class="container-lg bigger mb-5">
          <p>
            We've been providing permanent standby power solutions throughout Kentucky and Ohio since 2006.
            There is a good chance at least one of your neighbors has one of our generators installed 
            on their home right now.
          </p>
          <p>
            <a href="/contact">Contact us today</a> to find out how we can provide you peace of mind, 
            no matter what the weather throws at you.
          </p>
          <ul>
            <li>We beat our competitors' prices, often by <em>thousands of dollars</em>.</li>
            <li>Most jobs are completed in a <em>single day</em>.</li>
          </ul>
        </div>
        <div class="container-md">
          <div class="boxes">
            <a class="box" href=${generate(Routes.SERVICE, {}, { 'service-type': 'new-install' })}>
              <h2>Request a Quote</h2>
            </a>
            <a class="box" href=${generate(Routes.SERVICE, {}, { 'service-type': 'annual' })}>
              <h2>Schedule an Annual Service</h2>
            </a>
            <a class="box" href=${generate(Routes.PAY)}>
              <h2>Make a Payment</h2>
            </a>
            <a class="box" href=${generate(Routes.HELP)}>
              <h2>Need Help?</h2>
            </a>
          </div>
        </div>
        <div class="container-lg help">
          <h2>Having Trouble Finding What You Need</h2>
          <p>
            Feel free to <a href=${generate(Routes.CONTACT)}>contact us</a> and we can help you out.
          </p>
        </div>
        <div class="container-lg">
          <div class="call-to-action">
            <div>
              <h2>You know you've wanted to get a generator for years.</h2>
              <p>You don't have to put up with power outages any longer.</p>
            </div>
            <a class="btn btn-primary" href=${generate(Routes.SERVICE)}>
              Request A Service Or Quote
            </a>
          </div>
        </div>
        <div class="container-md">
          <facebook-bar></facebook-bar>
        </div>
      </main>
    `;
  }
}